(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const updateHeaderHeight = () => {
      const header = document.querySelector('.section-header') || document.querySelector('sticky-header');
      if (header && header.offsetHeight) {
        document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
      }
    };

    const initTimer = (section) => {
      const timerMode = section.getAttribute('data-timer-mode') || 'per_session';
      const evergreenHours = parseInt(section.getAttribute('data-evergreen-hours') || '5', 10);
      const evergreenMinutes = parseInt(section.getAttribute('data-evergreen-minutes') || '60', 10);
      const fixedEndTimeStr = section.getAttribute('data-fixed-end-time') || '';
      
      const hoursEl = section.querySelector('[data-timer-hours]');
      const minutesEl = section.querySelector('[data-timer-minutes]');
      const secondsEl = section.querySelector('[data-timer-seconds]');

      if (!hoursEl && !minutesEl) return;

      let targetTimestamp = 0;

      if (timerMode === 'fixed_time' && fixedEndTimeStr) {
        // Mode 2: Universal Fixed Time
        const parsed = new Date(fixedEndTimeStr).getTime();
        if (!isNaN(parsed) && parsed > Date.now()) {
          targetTimestamp = parsed;
        } else {
          // If past or invalid, fallback to next midnight
          const midnight = new Date();
          midnight.setHours(24, 0, 0, 0);
          targetTimestamp = midnight.getTime();
        }
      } else {
        // Mode 1: Per-Session / Evergreen (Beda tiap orang / session)
        const storageKey = `hg_announcement_timer_${section.getAttribute('data-hg-announcement-bar') || 'default'}`;
        const totalDurationMs = ((evergreenHours * 60) + evergreenMinutes) * 60 * 1000;
        
        let storedEnd = null;
        try {
          storedEnd = localStorage.getItem(storageKey);
        } catch (e) {}

        const now = Date.now();
        if (storedEnd && parseInt(storedEnd, 10) > now) {
          targetTimestamp = parseInt(storedEnd, 10);
        } else {
          targetTimestamp = now + totalDurationMs;
          try {
            localStorage.setItem(storageKey, targetTimestamp.toString());
          } catch (e) {}
        }
      }

      const updateClock = () => {
        const now = Date.now();
        let remaining = targetTimestamp - now;

        if (remaining <= 0) {
          if (timerMode === 'per_session') {
            // Auto restart evergreen timer for continuous excitement
            const totalDurationMs = ((evergreenHours * 60) + evergreenMinutes) * 60 * 1000;
            targetTimestamp = Date.now() + totalDurationMs;
            const storageKey = `hg_announcement_timer_${section.getAttribute('data-hg-announcement-bar') || 'default'}`;
            try {
              localStorage.setItem(storageKey, targetTimestamp.toString());
            } catch (e) {}
            remaining = totalDurationMs;
          } else {
            remaining = 0;
          }
        }

        const totalSec = Math.floor(remaining / 1000);
        const hrs = Math.floor(totalSec / 3600);
        const mins = Math.floor((totalSec % 3600) / 60);
        const secs = totalSec % 60;

        const formatTwoDigits = (num) => String(num).padStart(2, '0');

        if (hoursEl) hoursEl.textContent = formatTwoDigits(hrs);
        if (minutesEl) minutesEl.textContent = formatTwoDigits(mins);
        if (secondsEl) secondsEl.textContent = formatTwoDigits(secs);
      };

      updateClock();
      if (section.__timerInterval) clearInterval(section.__timerInterval);
      section.__timerInterval = setInterval(updateClock, 1000);
    };

    const initHgAnnouncementBar = (section) => {
      if (!section) return;
      updateHeaderHeight();
      initTimer(section);

      const stickyType = section.getAttribute('data-sticky-type');
      const sectionWrapper = section.closest('.shopify-section') || section;

      if (stickyType === 'on-scroll-up' && !section.__stickyHandlerAttached) {
        section.__stickyHandlerAttached = true;
        let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        window.addEventListener('scroll', () => {
          updateHeaderHeight();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const barHeight = section.offsetHeight || 40;

          if (scrollTop > lastScrollTop && scrollTop > barHeight + 100) {
            sectionWrapper.classList.add('hg-announcement-section--hidden');
          } else if (scrollTop < lastScrollTop || scrollTop <= 0) {
            sectionWrapper.classList.remove('hg-announcement-section--hidden');
          }
          lastScrollTop = Math.max(0, scrollTop);
        }, { passive: true });
      }
    };

    const updateAllHgAnnouncementBars = () => {
      updateHeaderHeight();
      document.querySelectorAll('[data-hg-announcement-bar]').forEach((section) => initHgAnnouncementBar(section));
    };

    if (window.__hgAnnouncementBarInitialized) {
      updateAllHgAnnouncementBars();
      return;
    }

    window.__hgAnnouncementBarInitialized = true;

    let resizeTimeout;
    const queueUpdate = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(updateAllHgAnnouncementBars, 100);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateAllHgAnnouncementBars, { once: true });
    } else {
      updateAllHgAnnouncementBars();
    }

    window.addEventListener('resize', queueUpdate);
    document.addEventListener('shopify:section:load', (e) => {
      queueUpdate();
      if (e.target) initHgAnnouncementBar(e.target.querySelector('[data-hg-announcement-bar]'));
    });
    document.addEventListener('shopify:section:reorder', queueUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-home-product-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Layout 1 Drag Scroll
    const dragThreshold = 8;
    const mobileMediaQuery = window.matchMedia('(max-width: 639px)');

    document.querySelectorAll('.hg-home-product-grid__track').forEach((track) => {
      if (track.dataset.dragScrollReady === 'true' || track.dataset.mobileLayout !== 'slider') {
        return;
      }

      track.dataset.dragScrollReady = 'true';

      let activePointerId = null;
      let startX = 0;
      let startScrollLeft = 0;
      let didDrag = false;

      const finishDrag = (event) => {
        if (activePointerId === null || event.pointerId !== activePointerId) {
          return;
        }

        if (track.hasPointerCapture(activePointerId)) {
          track.releasePointerCapture(activePointerId);
        }

        activePointerId = null;
        track.classList.remove('is-pointer-down', 'is-dragging');

        window.setTimeout(() => {
          didDrag = false;
        }, 0);
      };

      track.addEventListener('pointerdown', (event) => {
        if (!mobileMediaQuery.matches || event.pointerType !== 'mouse' || event.button !== 0) {
          return;
        }

        activePointerId = event.pointerId;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;
        didDrag = false;

        track.setPointerCapture(activePointerId);
        track.classList.add('is-pointer-down');
      });

      track.addEventListener('pointermove', (event) => {
        if (activePointerId === null || event.pointerId !== activePointerId) {
          return;
        }

        const distance = event.clientX - startX;

        if (!didDrag && Math.abs(distance) >= dragThreshold) {
          didDrag = true;
          track.classList.add('is-dragging');
        }

        if (!didDrag) {
          return;
        }

        event.preventDefault();
        track.scrollLeft = startScrollLeft - distance;
      });

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);

      track.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (!didDrag) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
        });
      });
    });

    // Layout 2 Infinite Looping Slider
    function initHgInfiniteSliders() {
      document.querySelectorAll('.hg-slider-v2').forEach((slider) => {
        if (slider.dataset.sliderReady === 'true') return;
        slider.dataset.sliderReady = 'true';

        const track = slider.querySelector('[data-track]');
        if (!track) return;

        const originalSlides = Array.from(track.querySelectorAll('[data-slide]'));
        const N = originalSlides.length;
        if (N < 2) return;

        // Clean up previous clones if re-initializing
        track.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());

        // Clone 2 sets before and 2 sets after (5 sets total)
        const preFragment = document.createDocumentFragment();
        for (let s = 0; s < 2; s++) {
          originalSlides.forEach((slide) => {
            const clone = slide.cloneNode(true);
            clone.setAttribute('data-clone', 'true');
            clone.setAttribute('aria-hidden', 'true');
            preFragment.appendChild(clone);
          });
        }
        track.insertBefore(preFragment, track.firstChild);

        const postFragment = document.createDocumentFragment();
        for (let s = 0; s < 2; s++) {
          originalSlides.forEach((slide) => {
            const clone = slide.cloneNode(true);
            clone.setAttribute('data-clone', 'true');
            clone.setAttribute('aria-hidden', 'true');
            postFragment.appendChild(clone);
          });
        }
        track.appendChild(postFragment);

        const realStartIndex = 2 * N;
        let currentIndex = realStartIndex;
        let isAnimating = false;

        function getStep() {
          const all = track.children;
          if (all.length < 2) return 0;
          const r0 = all[0].getBoundingClientRect();
          const r1 = all[1].getBoundingClientRect();
          return r1.left - r0.left;
        }

        function setPosition(animate, duration = 320) {
          const step = getStep();
          const offset = -(currentIndex * step);
          if (animate) {
            track.style.transition = `transform ${duration}ms cubic-bezier(0.25, 1, 0.5, 1)`;
          } else {
            track.style.transition = 'none';
          }
          track.style.transform = `translate3d(${offset}px, 0, 0)`;
        }

        // Set initial position immediately & after layout render
        setPosition(false);
        window.requestAnimationFrame(() => {
          setPosition(false);
        });

        function slideNext() {
          if (isAnimating) return;
          isAnimating = true;
          currentIndex++;
          setPosition(true, 320);
        }

        function slidePrev() {
          if (isAnimating) return;
          isAnimating = true;
          currentIndex--;
          setPosition(true, 320);
        }

        // Boundary normalization when sliding into clone sets
        track.addEventListener('transitionend', (e) => {
          if (e.target !== track || e.propertyName !== 'transform') return;

          const offsetWithinCycle = (((currentIndex - realStartIndex) % N) + N) % N;
          const normalizedIndex = realStartIndex + offsetWithinCycle;

          if (normalizedIndex !== currentIndex) {
            currentIndex = normalizedIndex;
            setPosition(false);
            void track.offsetHeight;
          }
          isAnimating = false;
        });

        // Desktop and mobile arrow buttons
        const prevBtns = slider.querySelectorAll('[data-arrow-prev], [data-mobile-prev]');
        const nextBtns = slider.querySelectorAll('[data-arrow-next], [data-mobile-next]');

        prevBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            slidePrev();
          });
        });

        nextBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            slideNext();
          });
        });

        // Touch & pointer dragging
        let isPointerDown = false;
        let startX = 0;
        let dragDelta = 0;
        let startTranslate = 0;
        let hasMoved = false;

        track.addEventListener('pointerdown', (e) => {
          if (isAnimating) return;
          if (e.target.closest('button')) return;

          isPointerDown = true;
          hasMoved = false;
          startX = e.clientX;
          dragDelta = 0;
          startTranslate = -(currentIndex * getStep());

          track.style.transition = 'none';
          track.classList.add('is-dragging');
          if (track.setPointerCapture) {
            track.setPointerCapture(e.pointerId);
          }
        });

        track.addEventListener('pointermove', (e) => {
          if (!isPointerDown) return;
          dragDelta = e.clientX - startX;
          if (Math.abs(dragDelta) > 5) {
            hasMoved = true;
          }
          track.style.transform = `translate3d(${startTranslate + dragDelta}px, 0, 0)`;
        });

        const finishPointer = (e) => {
          if (!isPointerDown) return;
          isPointerDown = false;
          track.classList.remove('is-dragging');
          if (track.hasPointerCapture && track.hasPointerCapture(e.pointerId)) {
            track.releasePointerCapture(e.pointerId);
          }

          const step = getStep();
          const threshold = Math.min(50, step * 0.2);

          if (dragDelta < -threshold) {
            slideNext();
          } else if (dragDelta > threshold) {
            slidePrev();
          } else {
            setPosition(true, 250);
          }
        };

        track.addEventListener('pointerup', finishPointer);
        track.addEventListener('pointercancel', finishPointer);

        // Prevent card link navigation when user drags
        track.addEventListener(
          'click',
          (e) => {
            if (hasMoved && Math.abs(dragDelta) > 8) {
              e.preventDefault();
              e.stopPropagation();
            }
          },
          true
        );

        // Resize responsiveness
        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            setPosition(false);
          }, 100);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHgInfiniteSliders);
    } else {
      initHgInfiniteSliders();
    }

    document.addEventListener('shopify:section:load', (e) => {
      const slider = e.target.querySelector('.hg-slider-v2');
      if (slider) {
        delete slider.dataset.sliderReady;
        initHgInfiniteSliders();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
